var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0274b3",
    d: "M482 10H30c-11 0-20 9-20 20v452c0 11 9 20 20 20h452c11 0 20-9 20-20V30c0-11-9-20-20-20zm0 0",
    opacity: 1,
    "data-original": "#0274b3",
    className: "hovered-path"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M166 124c0 23.61-19.14 42.75-42.75 42.75S80.5 147.61 80.5 124s19.14-42.75 42.75-42.75S166 100.39 166 124zM86.5 196.75H160v234H86.5zM204 196.75v234h73.5V295.687c0-22.136 18.11-40.25 40.25-40.25 22.137 0 40.25 18.114 40.25 40.25V430.75h73.5V279c0-47.988-39.262-87.25-87.25-87.25-28.883 0-54.598 14.227-70.5 36.012V196.75zm0 0",
    opacity: 1,
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382 492H30c-5.516 0-10-4.484-10-10V30c0-5.516 4.484-10 10-10h20c5.523 0 10-4.477 10-10S55.523 0 50 0H30C13.457 0 0 13.457 0 30v452c0 16.543 13.457 30 30 30h352c5.52 0 10-4.477 10-10s-4.477-10-10-10zM482 0H130c-5.523 0-10 4.477-10 10s4.477 10 10 10h352c5.516 0 10 4.484 10 10v452c0 5.516-4.484 10-10 10h-20c-5.523 0-10 4.477-10 10s4.477 10 10 10h20c16.543 0 30-13.46 30-30V30c0-16.543-13.457-30-30-30zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25 176.75c29.086 0 52.75-23.664 52.75-52.75 0-29.09-23.664-52.75-52.75-52.75-29.09 0-52.75 23.664-52.75 52.75s23.66 52.75 52.75 52.75zm0-85.5c18.059 0 32.75 14.691 32.75 32.75s-14.691 32.75-32.75 32.75S90.5 142.059 90.5 124s14.691-32.75 32.75-32.75zM344.25 181.75c-22.102 0-43.434 7.688-60.5 21.273v-6.273c0-5.523-4.48-10-10-10H204c-5.523 0-10 4.477-10 10v234c0 5.523 4.477 10 10 10h73.5c5.52 0 10-4.477 10-10V295.687c0-16.68 13.57-30.25 30.25-30.25s30.25 13.57 30.25 30.25V430.75c0 5.523 4.477 10 10 10h73.5c5.52 0 10-4.477 10-10V279c0-53.625-43.629-97.25-97.25-97.25zm77.25 239H368V295.687c0-27.707-22.543-50.25-50.25-50.25-27.71 0-50.25 22.543-50.25 50.25V420.75H214v-214h49.75v21.012a9.999 9.999 0 0 0 18.074 5.894c14.586-19.976 37.922-31.906 62.426-31.906 42.594 0 77.25 34.652 77.25 77.25zM86.5 186.75c-5.523 0-10 4.477-10 10v234c0 5.523 4.477 10 10 10H160c5.52 0 10-4.477 10-10v-234c0-5.523-4.48-10-10-10zm63.5 234H96.5v-214H150zM90.004 20c5.52 0 10-4.477 10-10s-4.48-10-10-10h-.008C84.473 0 80 4.477 80 10s4.48 10 10.004 10zM422.004 492h-.008c-5.523 0-9.996 4.477-9.996 10s4.48 10 10.004 10c5.523 0 10-4.477 10-10s-4.477-10-10-10zm0 0",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bebdd03468d1152c951abb2b6d1e254f.svg";
export { ForwardRef as ReactComponent };